// client/src/components/WhatsappSender.js
// <!-- by Majed Developer Solution © 2025 -->

import React, { useState } from 'react';
import axios from 'axios';

export default function WhatsappSender({ place, onClose }) {

  const [phone, setPhone]       = useState('');
  const [uniqueCode, setCode]   = useState(place.place_id);
  const [sending, setSending]   = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSendQR = async () => {
    setSending(true);
    setFeedback('');
    try {
      await axios.post('/api/sendWithQr', { phone, place, uniqueCode });
      setFeedback('✔ QR Sent / تم إرسال QR!');
    } catch (e) {
      setFeedback('❌ Error sending QR!');
    } finally {
      setSending(false);
    }
  };

  const handleSendNoQR = async () => {
    setSending(true);
    setFeedback('');
    try {
      await axios.post('/api/send', { phone, place, uniqueCode });
      setFeedback('✔ Sent (No QR) / تم الإرسال بدون QR!');
    } catch (e) {
      setFeedback('❌ Error sending message!');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: "22px",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(0,0,0,0.12)"
      }}
      className="mt-4"
    >

      <div
        style={{
          background: "#075e54",
          color: "#fff",
          padding: "14px 22px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: "1.1rem"
        }}
      >
        Send WhatsApp / إرسال واتساب

        <span
          onClick={onClose}
          style={{
            cursor: "pointer",
            background: "#fff",
            color: "#075e54",
            padding: "4px 10px",
            borderRadius: "14px",
            fontSize: "0.9rem",
            fontWeight: "bold"
          }}
        >
          ✕
        </span>
      </div>

      <div style={{ padding: "20px" }}>

        <div
          style={{
            marginBottom: "15px",
            background: "#dcf8c6",
            padding: "12px 15px",
            borderRadius: "18px",
            fontSize: "1rem"
          }}
        >
          <strong>📍 {place.name}</strong>
        </div>

        <div className="mb-3">
          <label className="fw-bold mb-1">📱 Phone / رقم الهاتف</label>
          <input
            type="text"
            placeholder="+965..."
            className="form-control form-control-lg"
            style={{ borderRadius: "16px" }}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="fw-bold mb-1">🔐 Code / الكود</label>
          <input
            type="text"
            className="form-control form-control-lg"
            style={{ borderRadius: "16px" }}
            value={uniqueCode}
            onChange={(e) => setCode(e.target.value)}
          />
        </div>

        {feedback && (
          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              textAlign: "center",
              background: "#c6f6d5",
              borderRadius: "14px",
              padding: "10px",
              fontWeight: "bold"
            }}
          >
            {feedback}
          </div>
        )}
      </div>

      {/* BUTTONS */}
      <div
        style={{
          background: "#f0f0f0",
          padding: "14px 18px",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          borderTop: "1px solid #ddd"
        }}
      >

        <button
          className="btn w-100"
          style={{
            background: "#25D366",
            borderRadius: "22px",
            fontWeight: "bold",
            fontSize: "1.3rem",
            padding: "14px 8px"
          }}
          onClick={handleSendQR}
          disabled={sending || !phone || !uniqueCode}
        >
          {sending ? "…" : "Send WITH QR / إرسال مع QR"}
        </button>

        <button
          className="btn w-100"
          style={{
            background: "#128C7E",
            borderRadius: "22px",
            fontWeight: "bold",
            fontSize: "1.3rem",
            padding: "14px 8px"
          }}
          onClick={handleSendNoQR}
          disabled={sending || !phone}
        >
          {sending ? "…" : "Send WITHOUT QR / إرسال بدون QR"}
        </button>

      </div>

    </div>
  );
}
